import { FC } from "react";
import { cn } from "../lib/helpers";
import * as styles from "./InfoGraphicListTitle.module.scss";

export interface InfoGraphicListTitleProps {
  label: string;
  date: string;
  color: "orange" | "blue";
}

const InfoGraphicListTitle: FC<InfoGraphicListTitleProps> = ({
  label,
  date,
  color = "orange",
}) => {
  return (
    <div className={cn(styles.root, styles[color])}>
      <div className={styles.label}>{label}</div>
      <div className={styles.date}>{date}</div>
    </div>
  );
};

export default InfoGraphicListTitle;
